import { useSupportNotifs } from "../pages/platform/support/useSupportNotifs";
import { useHealthAlerts } from "../pages/platform/monitoring/useHealthAlerts";

const TICKET_LABEL = { new: "Tiket baru", reply: "Balasan pengguna", escalated: "Eskalasi L2" };

// Merges ticket notifications (support roles) and system-health alerts (all staff) into one bell feed.
export function useConsoleNotifs({ support, staff, uid, pathname }) {
  const t = useSupportNotifs(support, uid, pathname);
  const h = useHealthAlerts(staff, uid);
    const tickets = t.items.map((n) => ({ key: n.key, kind: n.kind, at: n.at, read: n.read, label: TICKET_LABEL[n.kind], meta: n.ticket.number, title: n.ticket.subject, sub: n.ticket.user_email || n.ticket.user_name, to: `/support/tickets/${n.ticket.id}`, tid: `${n.ticket.id}-${n.kind}`, src: "t" }));
    const health = h.items.map((a) => ({ ...a, tid: a.cond.replace(/[^a-z0-9-]/gi, "-"), src: "h" }));
    const rank = (n) => (n.src === "h" && !n.read ? 0 : 1);
    const items = [...health, ...tickets].sort((a, b) => rank(a) - rank(b) || String(b.at).localeCompare(String(a.at)));
    const markRead = (key) => (health.some((a) => a.key === key) ? h.mark([key]) : t.markRead(key));
    return {
      items, unread: items.filter((n) => !n.read).length, loading: t.loading, healthCount: health.filter((a) => !a.read).length,
      refresh: () => { t.refresh(); h.refresh(); }, markRead,
      markAll: () => { t.markAll(); h.mark(health.map((a) => a.key)); },
    };
}
